import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import { FaFacebookSquare } from "react-icons/fa"
import { FaInstagram } from "react-icons/fa"
import { FaTwitter } from "react-icons/fa";


const Header = ({ siteTitle }) => (
  <header className="bg-gray-900 sticky top-0 w-full z-20">
    <div className="container mx-auto flex flex-col md:flex-row items-center px-5 py-5">
      <div className="flex flex-col md:flex-row items-center justify-center md:justify-start">
        <h1 className="font-bold font-heading uppercase text-2xl leading-none inline-block md:mr-8 mb-4 md:mb-0">
          <Link to="/" className="text-white" activeClassName="text-teal-200">
            {siteTitle}
          </Link>
        </h1>
        <div>
          <Link
            className="text-white mr-8 font-bold text-lg font-heading uppercase"
            to="/watch"
            activeClassName="text-teal-200"
          >
            Watch
          </Link>
          <Link
            className="text-white mr-8 font-bold text-lg font-heading uppercase"
            to="/synopsis"
            activeClassName="text-teal-200"
          >
            Synopsis
          </Link>
          <Link
            className="text-white md:mr-8 font-bold text-lg font-heading uppercase"
            to="/updates"
            activeClassName="text-teal-200"
          >
            Updates
          </Link>
        </div>
      </div>
      <div className="flex items-center md:ml-auto mt-4 md:mt-0">
        <FaFacebookSquare size="1.75em" className="text-gray-200 mr-3" />
        <FaInstagram size="1.75em" className="text-gray-200 mr-3" />
        <FaTwitter size="1.75em" className="text-gray-200" />
      </div>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
